module.exports = __webpack_public_path__ + "1569a46fe7a8755dd13818f174f67a77.png";